// frontend/src/components/common/Button.jsx
import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: ${({ theme }) => theme?.borderRadius?.md || '6px'};
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.95rem;
  color: ${({ $variant, theme }) => ($variant === 'secondary' ? theme.colors.text : theme.colors.onPrimary)};
  background: ${({ $variant, theme }) => {
    if ($variant === 'primary') return theme.colors.primary;
    if ($variant === 'danger') return theme.colors.danger;
    if ($variant === 'secondary') return theme.colors.surface;
    return theme.colors.primary;
  }};

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Button = ({ children, variant = 'primary', ...props }) => {
  return (
    <StyledButton $variant={variant} {...props}>
      {children}
    </StyledButton>
  );
};

export default Button;
